import {ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ConfigurationModel} from "../configuration.model";
import {NgbNavChangeEvent} from "@ng-bootstrap/ng-bootstrap";
import {Subject} from "rxjs";
import {StateService} from "web-shared";
import {ItemsQuery} from "web-shared";
import {ItemGroupsQuery} from "web-shared";
import {ClassificatorValuesQuery, UsersQuery} from "common-shared";
import {IntegratedMasterService} from "../../integrated-master-editor/services/integrated-master.service";
import {EditComponent} from "web-shared";
import {SpecLineModel} from "web-shared";
import {NgForm} from "@angular/forms";
import {takeUntil} from "rxjs/operators";
import {IAppSettings} from "web-shared";
import {SpecLinesEditComponent} from "../../../common/spec/spec-lines-edit/spec-lines-edit.component";

@Component({
  selector: 'app-configuration-data-edit',
  templateUrl: './configuration-data-edit.component.html',
  styles: [
  ]
})
export class ConfigurationDataEditComponent extends EditComponent{
  @Input() configuration: ConfigurationModel;
  @Input() readonly = false;
  @Input() currentTab: string;
  @Input() wasValidated$: Subject<boolean> = new Subject<boolean>();
  @Input() shouldResetSaveState$: Subject<boolean>;
  @Output() changed = new EventEmitter<boolean>();
  @Output() setTab = new EventEmitter<string>();
  settings: IAppSettings;
  showPropertyLocalizations: boolean = false;
  @ViewChild(SpecLinesEditComponent, {static: false}) specLinesEditComponent: SpecLinesEditComponent;
  @ViewChild(NgForm, {static: true}) form: NgForm;

  constructor(private stateService: StateService, public itemsQuery: ItemsQuery, public itemGroupsQuery: ItemGroupsQuery, public classificatorValuesQuery: ClassificatorValuesQuery, public usersQuery: UsersQuery, private integratedMasterService: IntegratedMasterService, public changeDetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.stateService.settings$.subscribe(value => {
      this.settings = value;
    });

    this.form.statusChanges.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.changed.emit(this.form.pristine);
    });

    this.shouldResetSaveState$?.pipe(takeUntil(this.componentDestroyed)).subscribe(() => this.setFormPristine());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.currentTab || changes.configuration?.currentValue) && this.currentTab === 'ime' && this.configuration) {
      this.ensureImeLoaded();
    }
  }

  ensureImeLoaded(force = false) {
    if (force || !this.configuration.isImeLoaded()) {
      this.integratedMasterService.getAll(undefined, null, this.configuration.Id, false).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
        this.integratedMasterService.loadIme(this.configuration, value);
        this.changeDetector.detectChanges();
      });
    }
  }

  initialize(configuration: ConfigurationModel) {
    this.configuration = configuration;
    this.ensureImeLoaded(true);
  }

  setFormPristine(): void {
    Object.keys(this.form.controls).forEach(control => {
      this.form.controls[control].markAsPristine();
    });
    this.changed.emit(this.form.pristine);
  }
  selectTab($event: NgbNavChangeEvent) {
    if ($event?.nextId) {
      this.setTab.emit($event.nextId);
    }
  }

  onSpecChanged(specLineModel: SpecLineModel) {
    specLineModel?.ensureSources(this.configuration.Id, this.configuration.Code);
    this.setChanged();
  }

  setChanged() {
    this.form.controls.code.markAsDirty();
    this.changed.emit(this.form.pristine);
  }
}
